const s = {
  name: "RiceBowl",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,17H0v3c0,6.1,4.9,11,11,11h18c6.1,0,11-4.9,11-11v-3h-3c0-9.4-7.6-17-17-17S3,7.6,3,17z M5,17
			C5,8.7,11.7,2,20,2s15,6.7,15,15H5z M2,20v-1h36v1c0,5-4,9-9,9H11C6,29,2,25,2,20z"/>
		<path class="st0" d="M14.1,35.7L3.8,34l0.3-2L20,34.7L35.8,32l0.3,2l-10.3,1.8L39.2,38l-0.3,2L20,36.8L1.2,40l-0.3-2L14.1,35.7z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  s as RiceBowl
};
